import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { CssTextField } from 'components/select';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/user-preferences/store';
import HelpImg from 'pages/provisioning/_components/helpImg';

export const BudgetAmount = ({ index }) => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);

    const setBudgetAmount = (maxOrderAmount = 0) => {
        setOrder({
            ...order,
            ruleRows: order?.ruleRows?.map((row, i) => (i === index ? { ...row, value: maxOrderAmount } : row)),
        });
    };

    const validateInput = () => {
        if (isTouched && order?.isTouched && !order?.ruleRows[index]?.value) {
            return 'validate';
        }
        return '';
    };

    React.useEffect(() => {
        if (!order?.ruleRows[index]?.value && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.ruleRows, order?.isTouched]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <CssTextField
                size="small"
                sx={{
                    width: (theme) => theme.spacing('100%'),
                    '& .MuiFormHelperText-root': {
                        marginTop: (theme) => theme.spacing('-2'),
                    },
                }}
                autoComplete="off"
                label="Enter Your Budget Amount ($) *"
                value={order?.ruleRows[index]?.value || ''}
                onChange={(e) => setBudgetAmount(Number(e.target.value))}
                className={validateInput()}
                data-testid="budget-amount-text"
            />
            {order?.ruleRows?.[index]?.ruleType && (
                <HelpImg
                    title={
                        <Box>
                            Max Order Amount is the highest total value allowed for auto approvals, applying to a single order or combined orders, as long as
                            the total does not exceed this limit.
                        </Box>
                    }
                />
            )}
        </Box>
    );
};

BudgetAmount.propTypes = {
    index: PropTypes.number.isRequired,
};

export default React.memo(BudgetAmount);
